import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import AppLayoutMixin from '../../app-layout-mixin'
import {  NFormItem, NForm, NCard, NInputNumber, NInputGroup, NInputGroupLabel } from 'naive-ui'
import EmbedCode from "@/components/embed";

function intToBinary(int){
    let binStr = parseInt(int, 10).toString(2);
    binStr = "0".repeat(8 - binStr.length) + binStr;
    return binStr;
}

function binaryToInt(bin) {
    return parseInt(bin, 2);
}

String.prototype.insert = function(index, string) {
    if(index > 0)
        return this.toString().substring(0, index) + string + this.toString().substring(index, this.toString().length);
    else
        return string + this.toString();
};

createApp({
    components: {  NFormItem, NForm, NCard, NInputNumber, NInputGroup, NInputGroupLabel, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            oct0: 0,
            oct1: 0,
            oct2: 0,
            oct3: 0,
            prefix: 24
        }
    },
    computed: {

        Class() {
            if (this.prefix >= 8 && this.prefix <= 15) return 'A';
            else if(this.prefix >= 16 && this.prefix <= 23) return 'B';
            else if(this.prefix >= 24 && this.prefix <= 30) return 'C';
            else return '';
        },

        ipBinary() {
            const ipBin = [
                intToBinary(this.oct0 ? this.oct0 : 0),
                intToBinary(this.oct1 ? this.oct1 : 0),
                intToBinary(this.oct2 ? this.oct2 : 0),
                intToBinary(this.oct3 ? this.oct3 : 0)
            ];
            return ipBin.join('.');
        },

        subnetBinary() {
            let subnetBin = '1'.repeat(this.prefix);
            subnetBin += '0'.repeat(32 - subnetBin.length);
            subnetBin = subnetBin.insert(8, '.').insert(17, '.').insert(26, '.');
            return subnetBin;
        },

        networkBinary() {
            let netBin = '';
            for (let i = 0; i < 35; i++) {
                if( this.ipBinary[i] == this.subnetBinary[i]){
                    netBin += this.ipBinary[i];
                } else {
                    netBin += '0';
                }
            }
            return netBin
        },

        networkAddress() {
            return this.networkBinary.split('.').map(oct => {
                return binaryToInt(oct)
            }).join('.');
        },

        subnetMask() {
            let mask = '1'.repeat(this.prefix);
            mask += '0'.repeat(32-mask.length);
            mask = mask.replace(/\s*[01]{8}\s*/g, function(mask) {return parseInt(mask, 2).toString() + '.';});
            return mask.substring(0, mask.length-1);
        },

        subnetBits() {
            if (this.Class === 'A') return this.prefix - 8;
            else if (this.Class === 'B') return this.prefix - 16;
            else if (this.Class === 'C') return this.prefix - 24;
            else return 0;
        },

        totalSubnets() {
            return Math.pow(2, this.subnetBits);
        },

        hostsPerSubnet() {
            return Math.pow(2, 32 - this.prefix) - 2;
        },

        hostCount() {
            return (Math.pow(2, 32-this.prefix) - 2) * this.totalSubnets;
        },

        hostsLostToSubnets() {
            if (this.Class === 'A') return (16777214 - this.hostCount);
            else if(this.Class === 'B') return (65534 - this.hostCount);
            else if(this.Class === 'C') return (254 - this.hostCount);
            else return;
        }


    }
}).mount('#app')
